export const MOVE_BRASIL_FAQ = [
	{
		id: "gov",
		highlight: "FAQ Gov",
		title: "Perguntas institucionais",
		items: [
			{
				question: "O programa pede entrada mínima?",
				answer:
					"Não. O banco poderá financiar até 100% do valor do veículo, a depender da análise de crédito.",
			},
			{
				question: "Se aprovado no GOV, o financiamento está garantido?",
				answer:
					"Não. A aprovação no GOV valida apenas a elegibilidade do cliente ao programa. A aprovação do financiamento depende da análise de crédito da instituição financeira.",
			},
			{
				question:
					"O Programa Move Brasil financia carro usado ou apenas veículo novo?",
				answer:
					" O programa contempla exclusivamente veículos zero quilômetro.",
			},
			
		],
	},
	{
		id: "live",
		highlight: "FAQ Live",
		title: "Perguntas da transmissão",
		items: [
			{
				question:
					"Pessoas jurídicas (CNPJ) também podem comprar carro zero pelo programa?",
				answer:
					"NÃO. O Move Brasil Táxi e Aplicativos é exclusivo para pessoa física, e limitado a um carro por CPF.",
			},
			{
				question:
					"Posso fazer uma nova simulação se meu financiamento for recusado?",
				answer:
					"Sim. A recomendação é realizar uma nova simulação após a conclusão da integração via API. Há expectativa de maior flexibilidade nos critérios de análise de crédito ao longo do processo.",
			},
			{
				question:
					"Quanto tempo demora a aprovação do cadastro no Programa Move Brasil?",
				answer:
					"Em até 5 dias úteis após o cadastro na plataforma, o motorista receberá, via caixa postal do gov.br e via mensagem de WhatsApp, resposta sobre a análise de elegibilidade, ou seja, se ele pode ou não fazer parte do programa.",
			},
		],
	},
] as const;
